// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#app,
#root {
  width: 100%;
  height: 100% !important;
  margin: 0px !important;
}

body:not(.modal-open) {
  padding-right: inherit !important;
  overflow: inherit !important;
}

#body {
  min-height: 100% !important;
  position: relative;
  display: grid;
}

a {
  text-decoration: none;
  color: inherit;
}

#controlRegion a {
  text-decoration: underline !important;
  color: #0000aa !important;
  font-weight: 500;
}

#controlRegion a:hover {
  color: '#151515 !important';
}

.full-height {
  height: 100% !important;
}

.right {
  float: right !important;
}

.autoMargin {
  margin: auto !important;
}

.cursor {
  cursor: pointer;
}

.form-element {
  min-width: 300px !important;
}

.cancel-margin {
  margin-right: 20px !important;
}

.bottom-padding {
  padding-bottom: 50px !important;
}

.checkbox svg {
  fill: #2189c1 !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.horizondalAlignment {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/css/app.css"],"names":[],"mappings":"AAAA;;;;EAIE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,aAAa;AACf","sourcesContent":["html,\nbody,\n#app,\n#root {\n  width: 100%;\n  height: 100% !important;\n  margin: 0px !important;\n}\n\nbody:not(.modal-open) {\n  padding-right: inherit !important;\n  overflow: inherit !important;\n}\n\n#body {\n  min-height: 100% !important;\n  position: relative;\n  display: grid;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n#controlRegion a {\n  text-decoration: underline !important;\n  color: #0000aa !important;\n  font-weight: 500;\n}\n\n#controlRegion a:hover {\n  color: '#151515 !important';\n}\n\n.full-height {\n  height: 100% !important;\n}\n\n.right {\n  float: right !important;\n}\n\n.autoMargin {\n  margin: auto !important;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.form-element {\n  min-width: 300px !important;\n}\n\n.cancel-margin {\n  margin-right: 20px !important;\n}\n\n.bottom-padding {\n  padding-bottom: 50px !important;\n}\n\n.checkbox svg {\n  fill: #2189c1 !important;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.horizondalAlignment {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
